<div class="btn-group animated-dropdown" dropdown>
    <div role="button" class="toggle-group d-flex align-items-center" dropdownToggle>
        <span *ngIf="label" class="medium-title-text mr-xs">{{label}}</span>
        <ng-content select="[header]"></ng-content>
    </div>
    <ul id="dropdown-menu" role="menu" class="dropdown-menu border-radius-md p-4 mt-xs border-0" [ngClass]="{ 'dropdown-menu-right' : alignmentRight }" *dropdownMenu aria-labelledby="single-button">
        <ng-content></ng-content>
    </ul>
</div>